import axios from "axios";
import {RepositoryFactory} from "../../scripts/RepositoryFactory";

const ServiceRepository = RepositoryFactory.get('services');

const state = {
    sitesAndTypes: [],
    selectedPublisher: [],
    logs: [],
}
const getters = {
    publisher_sites(state, getters, rootState) {
        let ret = [];
        state.sitesAndTypes.forEach((sitetype) => {
            let sitesPublisher = JSON.parse(JSON.stringify(rootState.display.publisher.find(x => x.PublisherId === sitetype.PublisherId)));
            if ((state.selectedPublisher.length === 0 || state.selectedPublisher.find(x => x.PublisherId === sitesPublisher.PublisherId))) {
                let ret_publisher = ret.find(x => x.PublisherId === sitesPublisher.PublisherId);
                if (ret_publisher) {
                    ret_publisher.sites.push(sitetype);
                } else {
                    sitesPublisher.sites = [sitetype]
                    ret.push(sitesPublisher);
                }
            }
        });
        return ret;
    }
}
const actions = {
    async fetchSitesAndTypes({commit, rootState}) {
        let reqs = [];
        if (rootState.display.publisher) {
            rootState.display.publisher.forEach((publ) => {
                reqs.push(ServiceRepository.getSitesAndTypes(publ.PublisherId));
            });
            await axios.all(reqs).then(axios.spread((...responses) => {
                let sites = [];
                if (responses) {
                    responses.forEach((res) => {
                        let publisherId = parseInt(res.config.url.split('publisher_id=')[res.config.url.split('publisher_id=').length - 1]);
                        if (typeof res.data !== "undefined" && typeof res.data.Types !== "undefined") {
                            res.data.Types.forEach((type) => {
                                type.PublisherId = publisherId;
                            })
                            sites = sites.concat(res.data.Types);
                        }
                    });
                }
                commit('setSitesAndTypes', sites);
            }))
        }
    },
    async fetchLogs({commit}, payload) {
        let {data} = await ServiceRepository.getLogs(payload)
        if (data.Status) {
            commit('setLogs', data.Logs);
        }
    }
}
const mutations = {
    setSitesAndTypes(state, payload) {
        state.sitesAndTypes = payload;
    },
    updateSelectedPublisher(state, {data}) {
        state.selectedPublisher = data;
    },
    setLogs(state, payload) {
        state.logs = payload;
    }
}


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}